import { Component, OnInit } from '@angular/core';
import { IDeployPriorityGrading } from '../../interfaces/deploy-priority/deploy-priority-grading';
import { DeployPriorityGradingsService } from '../../services';
import { Message } from '../../classes/Message';
import { MessageService } from 'primeng';

@Component({
  selector: 'deploy-priority-gradings',
  templateUrl: './deploy-priority-gradings.component.html',
  //styleUrls: ['./job-deploy-priority-gradings.component.scss'],
})
export class JobDeployPriorityGradingsComponent implements OnInit {
  public gradings: IDeployPriorityGrading[] = [];

  public selectedGrading: IDeployPriorityGrading;

  public updateGradingDto: IDeployPriorityGrading;

  public showEditGrading: boolean = false;

  public saving: boolean = false;

  public loading: boolean = false;

  public isNewGrading: boolean = false;

  constructor(
    private jobDeployPriorityGradingsService: DeployPriorityGradingsService,
    private messageService: MessageService,
  ) {}

  onRowSelect() {
    this.isNewGrading = false;
    this.updateGradingDto = {
      ...this.selectedGrading,
    };
    this.showEditGrading = true;
  }

  addGrading() {
    this.isNewGrading = true;
    this.updateGradingDto = {
      id: 0,
      colour: '#ffffff',
      description: '',
      iconClass: '',
    };
    this.showEditGrading = true;
  }

  ngOnInit() {
    void this.getGradings();
  }

  async getGradings() {
    try {
      this.loading = true;
      const { items } = await this.jobDeployPriorityGradingsService.getGradings();
      this.gradings = items;
    } catch (e) {
    } finally {
      this.loading = false;
    }
  }

  async saveGrading() {
    this.saving = true;
    try {
      await this.jobDeployPriorityGradingsService.updateGrading(this.updateGradingDto);
      this.messageService.add(Message.Success('Grading updated'));
      this.showEditGrading = false;
      this.updateGradingDto = null;
      this.getGradings();
    } catch (e) {
      this.messageService.add(Message.Error('An error occurred whilst updating the grading'));
    } finally {
      this.saving = false;
    }
  }
}
